export const environment_org = {
    organization: 'AB',
    auht0_redirectUri: {
        local: 'https://localhost:4200/login',
        dev: 'https://front.g23-newpos-dev.net/login',
        stg: '',
        prod: ''
    },
}